import AssetManager from "../../common/AssetManager";
import { Action } from "../createDataContext";

export class FormState {
  ageLocationPairs: AgeLocationPair[];

  selectedAgeLocationPair: AgeLocationPair | "" = "";
  ageLocationPair: AgeLocationPair | null = null;
  selectedActivity: LocationSweatCommentPairs | "" = "";
  activity: LocationSweatCommentPairs | null = null;
  temperatureSelectType: TemperatureSelectType | null = null;
  temperatureValue: PossibleTemperatureValue | null = null;

  constructor() {
    const pairs: AgeLocationPair[] = AssetManager.getAsset(
      "/age_location_pairs_db.json"
    )["pairs"];

    this.ageLocationPairs = pairs;
  }
}

export interface AgeLocationPair {
  pairID: number;
  ageNameKey: string;
  ageGroup: number[];
  locationSweatCommentPairs: LocationSweatCommentPairs[];
}

export interface LocationSweatCommentPairs {
  location: number;
  sweatComment: number | null;
  fixedTemperatureRanges: TemperatureRange[] | null;
  wikiCategories: PairWikiCategory[] | null;
}

export interface TemperatureRange {
  isRecommended: boolean;
  temperature: number[];
}

export enum TemperatureSelectType {
  RANGE = "RANGE",
  SLIDER = "SLIDER",
}

export interface TemperatureValue {
  type: TemperatureSelectType;
  temperature: any;
}

export type PossibleTemperatureValue =
  | RangeTemperatureValue
  | SliderTemperatureValue;

export interface RangeTemperatureValue extends TemperatureValue {
  type: TemperatureSelectType;
  temperature: TemperatureRange;
}

export interface SliderTemperatureValue extends TemperatureValue {
  type: TemperatureSelectType;
  temperature: number;
}

export interface PairWikiCategory {
  categoryID: number;
  wikiList: number[];
}

export enum FormActionType {
  SELECT_AGE_LOCATION_PAIR = "SELECT_AGE_LOCATION_PAIR",
  SELECT_ACTIVITY = "SELECT_ACTIVITY",
  SELECT_TEMPERATURE = "SELECT_TEMPERATURE",
}

export type FormActions =
  | SelectAgeLocationPairAction
  | SelectActivityAction
  | SelectTemperatureAction;

export interface SelectAgeLocationPairAction extends Action {
  type: FormActionType.SELECT_AGE_LOCATION_PAIR;
  payload: {
    pairID: number | "";
  };
}

export interface SelectActivityAction extends Action {
  type: FormActionType.SELECT_ACTIVITY;
  payload: {
    activity: LocationSweatCommentPairs | "";
  };
}

export interface SelectTemperatureAction extends Action {
  type: FormActionType.SELECT_TEMPERATURE;
  payload: {
    temperatureValue: PossibleTemperatureValue;
  };
}
